export default {
  'purchasesPurchaseReport.form.filterByDate': 'Filtrar por data de',
  'purchasesPurchaseReport.form.filterByDate.launch': 'Lançamento',
  'purchasesPurchaseReport.form.filterByDate.emission': 'Emissão',

  'purchasesPurchaseReport.form.situation': 'Situação',
  'purchasesPurchaseReport.form.situation.open': 'Abertos',
  'purchasesPurchaseReport.form.situation.authorized': 'Autorizados',
  'purchasesPurchaseReport.form.situation.canceled': 'Cancelados',

  'purchasesPurchaseReport.form.itemsPurchase': 'Itens Compra',
  'purchasesPurchaseReport.form.itemsPurchase.parts': 'Peças',
  'purchasesPurchaseReport.form.itemsPurchase.consumables': 'Insumos',
  'purchasesPurchaseReport.form.itemsPurchase.tasks': 'Serviços',
  'purchasesPurchaseReport.form.itemsPurchase.freightInvoice': 'NF de Frete',

  'purchasesPurchaseReport.form.groupReportBy': 'Agrupar relatório por',
  'purchasesPurchaseReport.form.groupReportBy.date': 'Data',
  'purchasesPurchaseReport.form.groupReportBy.supplier': 'Fornecedor',
  'purchasesPurchaseReport.form.groupReportBy.workOders': 'Orçamentos',
  'purchasesPurchaseReport.form.groupReportBy.cfop': 'CFOP',
  'purchasesPurchaseReport.form.groupReportBy.documentType':
    'Tipo de Documento',

  'purchasesPurchaseReport.form.purchaseCode': 'Código Compra',
  'purchasesPurchaseReport.form.accessKey': 'Chave de acesso',
  'purchasesPurchaseReport.form.documentNumber': 'Nº do documento',

  'purchasesPurchaseReport.form.moreOptions': 'Mais Opções',
  'purchasesPurchaseReport.form.moreOptions.button.selectSuppliers':
    'Selecionar Fornecedores',
  'purchasesPurchaseReport.form.moreOptions.button.selectDocumentType':
    'Selecionar Tipo de Documento',
  'purchasesPurchaseReport.form.moreOptions.button.selectCfop':
    'Selecionar CFOP',
  'purchasesPurchaseReport.form.moreOptions.button.selectWorkOrder':
    'Selecionar Orçamento',
};
